import PageSidebar from './page-siderbar';

export default PageSidebar;